module.exports = __webpack_public_path__ + "dimer/static/img/logo3.362c1db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/logo3.jpg
// module id = gqz6
// module chunks = 0